<template>
  <span>
    <img src="../../assets/images/logo/logo_open.svg" width="130" height="36" v-show="isOpen">
    <img src="../../assets/images/logo/logo_close.svg" width="38" height="36" v-show="!isOpen">
  </span>
</template>
<script>
export default {
  name: "logo",
  props: {
    isOpen: { type: Boolean, default: true },
  },
};
</script>
